import React, { Component } from 'react';
import { Field, ErrorMessage } from 'formik';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { iconForField } from '../../../common/custom/icon-library';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import BrowserStorageLocationField from './BrowserStorageLocationField';
import { getFieldDescriptionInfoByName } from '../ActionFormUtils.js';

class BrowserStorageOptions extends Component {
  showSaveCompleteResponseOption = (values) => {
    if (!values['passPreviousActionResponse']) return '';

    const { actionData } = this.props;
    return (
      <div style={{ marginLeft: '30px' }}>
        <div className="input-group">
          <div className="input-group-prepend" title={'Save Full API Response'}>
            <span className="input-group-text">
              <i className={`wb ${iconForField('boolean-toggle')}`}></i>
            </span>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Field
                type="checkbox"
                name={'saveCompleteAPIResponse'}
                className="form-check-input"
                title={'saveCompleteAPIResponse'}
              />
              {'Save Full API Response '}
              <span className="form-check-sign">
                <span className="check"></span>
              </span>
            </label>
            <ErrorMessage name={'saveCompleteAPIResponse'}>
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </div>
          {getFieldDescriptionInfoByName(
            { name: 'saveCompleteAPIResponse', label: 'Save Full API Response' },
            actionData,
          )}
        </div>
      </div>
    );
  };
  render() {
    const {
      values,
      setFieldValue,
      setFieldTouched,
      validateFormDataSessionKey,
      validateResponseDataSessionKey,
      sendPreviousActionResponseItemId,
      validateRefItemDataSessionKey,
      saveRefItemIdInBrowserSession,
      saveFormDataInBrowserStorage = true,
      saveFullResponseToBrowserStorage = false,
    } = this.props;

    return (
      <div style={{ marginLeft: '30px' }}>
        {/* Form Submission Data */}
        {saveFormDataInBrowserStorage && (
          <div className="form-group">
            <div className="input-group">
              <div
                className="input-group-prepend"
                title="Save Form Submission Data In Browser Session Storage"
              >
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="passPreviousActionFormData"
                    className="form-check-input"
                    title="passPreviousActionFormData"
                  />
                  Save Form Submission Data In Browser Storage
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to save form submission data in your web browser storage.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage
              name="passPreviousActionFormData"
              component="p"
              className="text-error ml-5"
            />
          </div>
        )}

        {values['passPreviousActionFormData'] && (
          <div style={{ marginLeft: '30px' }}>
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Form Data Session Key"
                icon="text"
                infoIcon={true}
                infoDescription={`Enter the key in which you want to save form submission data in your web browser storage.`}
              >
                <Field
                  type="text"
                  name="formDataSessionKey"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Form Data Session Key"
                  validate={validateFormDataSessionKey}
                />
              </FormFieldWithLabel>
              <ErrorMessage name="formDataSessionKey" component="p" className="text-error ml-5" />
            </div>
            <BrowserStorageLocationField
              fieldName={'formDataBrowserStorageLocation'}
              values={values}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
            />
          </div>
        )}

        {/* Response Data */}
        <div className="form-group">
          <div className="input-group">
            <div
              className="input-group-prepend"
              title="Save Response Data In Browser Session Storage"
            >
              <span className="input-group-text">
                <i className={`wb ${iconForField('boolean-toggle')}`}></i>
              </span>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <Field
                  type="checkbox"
                  name="passPreviousActionResponse"
                  className="form-check-input"
                  title="passPreviousActionResponse"
                />
                Save Response Data In Browser Storage
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </label>
            </div>
            <TooltipInfo
              title={`Enable it to save action response data in your web browser storage.`}
              headerText={`What's this ?`}
              showHeader={true}
              showArrow={true}
              append={true}
            />
          </div>
          <ErrorMessage
            name="passPreviousActionResponse"
            component="p"
            className="text-error ml-5"
          />
        </div>

        {values['passPreviousActionResponse'] && (
          <>
            {saveFullResponseToBrowserStorage && this.showSaveCompleteResponseOption(values)}
            <div style={{ marginLeft: '30px' }}>
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Response Data Session Key"
                  icon="text"
                  infoIcon={true}
                  infoDescription={`Enter the key in which you want to save response data in your web browser storage.`}
                >
                  <Field
                    type="text"
                    name="responseDataSessionKey"
                    className="form-control form-control-sm"
                    autoComplete="off"
                    placeholder="Response Data Session Key"
                    validate={validateResponseDataSessionKey}
                  />
                </FormFieldWithLabel>
                <ErrorMessage
                  name="responseDataSessionKey"
                  component="p"
                  className="text-error ml-5"
                />
              </div>
              <BrowserStorageLocationField
                fieldName={'responseDataSessionStorageLocation'}
                values={values}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
              />
            </div>
          </>
        )}

        {/* Used in saveCollectionWithReferenceItemsResponse & updateCollectionWithReferenceItems action to save Reference Id in Browser Session */}
        {saveRefItemIdInBrowserSession && (
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Save Reference Item In Browser Storage">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="saveReferenceItemsToSession"
                    className="form-check-input"
                    title="saveReferenceItemsToSession"
                  />
                  Save Reference Item In Browser Storage
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to save reference item id in your web browser storage.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage
              name="saveReferenceItemsToSession"
              component="p"
              className="text-error ml-5"
            />
          </div>
        )}
        {saveRefItemIdInBrowserSession && values['saveReferenceItemsToSession'] && (
          <div style={{ marginLeft: '30px' }}>
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Response Data Session Key"
                icon="text"
                infoIcon={true}
                infoDescription={`Enter the key in which you want to save reference item id in your web browser storage.`}
              >
                <Field
                  type="text"
                  name="referenceItemSessionKey"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Response Data Session Key"
                  validate={validateRefItemDataSessionKey}
                />
              </FormFieldWithLabel>
              <ErrorMessage
                name="referenceItemSessionKey"
                component="p"
                className="text-error ml-5"
              />
            </div>
            <BrowserStorageLocationField
              fieldName={'referenceItemSessionStorageLocation'}
              values={values}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
            />
          </div>
        )}

        {/* Send Previous Action Response Item Id */}
        {sendPreviousActionResponseItemId && (
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Send Item Id of previous action response">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="sendPreviousActionResponseItemId"
                    className="form-check-input"
                    title="Send Item Id of previous action response"
                  />
                  Send Item Id of previous action response
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to send the Item Id created/updated in the previous action step instead of Item Id from the collection bounded page.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage
              name="sendPreviousActionResponseItemId"
              component="p"
              className="text-error ml-5"
            />
          </div>
        )}
      </div>
    );
  }
}

export default BrowserStorageOptions;
